import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputForm from "../forms/inputForm";
import SelectForm from "../forms/selectFormm";
import { useAppDispatch } from "../../../store";
import { useEffect, useState } from "react";
import useDebouncedEffect from "../../../hooks/useDebouncedEffect";
import DatePickerForm from "../forms/datePickerForm";
import dayjs from "dayjs";

const schema = yup.object({
  title: yup.string().required(),
});

const SatpasDeviceSearch = ({ params, setParams }: any) => {
  const [searchFilterDebounced, setSearchFilterDebounced] = useState("");
  const [deviceId, setDeviceId] = useState("");
  const [hostname, setHostname] = useState("");
  const [enrolledStart, setEnrolledStart] = useState("");
  const [enrolledEnd, setEnrolledEnd] = useState("");
  const [userActive, setUserActive] = useState(""); // TODO: NEED PARAMETER FROM API
  const dispatch = useAppDispatch();

  const {
    control,
    formState: { errors },
  } = useForm<{
    deviceId: string;
    hostname: string;
    enrolledStart: string;
    enrolledEnd: string;
  }>({
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {
      deviceId: "",
      hostname: "",
      enrolledStart: "",
      enrolledEnd: "",
    },
  });

  const optSelect = [
    {
      label: "Active",
      value: "ACTIVE",
    },
    {
      label: "Inactive",
      value: "INACTIVE",
    },
    {
      label: "Registered",
      value: "REGISTERED",
    },
  ];

  const handleDeviceId = (e: string) => { setDeviceId(e); };
  const handleHostnameSelect = (e: any) => { setHostname(e); };
  const handleStatusSelect = (e: any) => { setUserActive(e.value); }; 
  const handleEnrolledStart = (e: any) => {
    let NewDate: any;
    if (e !== null) {
      NewDate = dayjs(e).format("YYYY-MM-DD");
    } else {
      NewDate = "";
    }
    setEnrolledStart(NewDate);
  };
  const handleEnrolledEnd = (e: any) => {
    let NewDate: any;
    if (e !== null) {
      NewDate = dayjs(e).format("YYYY-MM-DD");
    } else {
      NewDate = "";
    }
    setEnrolledEnd(NewDate);
  };

  useDebouncedEffect(() => setSearchFilterDebounced(deviceId), [deviceId], 500);
  useDebouncedEffect(() => setSearchFilterDebounced(hostname), [hostname], 500);
  useDebouncedEffect(() => setSearchFilterDebounced(userActive), [userActive], 500); 
  useDebouncedEffect(() => setSearchFilterDebounced(enrolledStart), [enrolledStart], 500); 
  useDebouncedEffect(() => setSearchFilterDebounced(enrolledEnd), [enrolledEnd], 500); 

  useEffect(() => {
    setParams({
      ...params,
      param_filter_device_id: deviceId,
      param_filter_hostname: hostname,
      param_filter_enrolled_start: enrolledStart,
      param_filter_enrolled_end: enrolledEnd,
      param_filter_status: userActive, 
    });
  }, [searchFilterDebounced]);
  

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "row", gap: "1rem", flex: 1 }}>
        <InputForm
          name="deviceId"
          errors={errors}
          control={control}
          required
          placeholder="Device ID"
          maxLength={100}
          isLoading={false}
          onChange={handleDeviceId}
        />
        <InputForm
          name="hostname"
          errors={errors}
          control={control}
          required
          placeholder="Hostname"
          maxLength={100}
          isLoading={false}
          onChange={handleHostnameSelect}
        />
        <DatePickerForm
          name="enrolledStart"
          defaultValue={null}
          control={control}
          errors={errors}
          placeholder="Start Enrolled"
          disabled={false}
          isLoading={false}
          required
          onChange={handleEnrolledStart}
        />
        <DatePickerForm
          name="enrolledEnd"
          defaultValue={null}
          control={control}
          errors={errors}
          placeholder="End Enrolled"
          disabled={false}
          isLoading={false}
          required
          onChange={handleEnrolledEnd}
        />
        <SelectForm 
          name="status"
          defaultValue={1}
          options={optSelect}
          placeholder="Status"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          required
          sxFL={{ backgroundColor: "red" }}
          onChangeForm={handleStatusSelect}
        />
      </Box>
    </Box>
  );
};

export default SatpasDeviceSearch;
